import { Checkbox, FormControlLabel } from '@mui/material'
import colors from '../../constants/colors'
import { IFilterObject } from '../FilterComponent'
import constants from './constants'

const renderCheckboxes = (items: IFilterObject[], onChange: any, section: string) => {
  return items.map((item, index) => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            value={item?.value}
            sx={{ color: colors.BLACK, '&.Mui-checked': { color: colors.BLACK } }}
            onChange={e => {
              onChange(e, constants.sectionNames[section])
            }}
            checked={item?.checked}
          />
        }
        label={item?.title}
        key={`${item?.value}-${index}`}
      />
    )
  })
}

export default {
  renderCheckboxes,
}
